<template>
    <v-container>
            <v-col
                class="text-center"
                md="6" offset-md="3"
            >
                <v-card>
                    <v-card-title class="text-h5 grey lighten-2 justify-center">
                        Login
                    </v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="login">
                            <v-text-field type="username" label="Username" v-model="username"></v-text-field>
                            <v-text-field type="password" label="Password" v-model="password"></v-text-field>
                            <v-btn
                                depressed
                                color="primary"
                                type="submit"
                            >
                                Login
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
            <div v-if="showMessage">
                <ShowError @closesnackbar="closesnackbar"/>
            </div>
    
    </v-container>
</template>

<script setup>
    import { ref , provide } from 'vue'
    import AuthenticationService from '@/services/AuthenticationService'
    import ShowError from '@/components/Showerror'
    import { useAuthStore } from '@/stores/AuthStore'
    import router from '@/router'

    const authStore = useAuthStore()
    const username = ref('')
    const password = ref('')
    var error = ref('')
    const valid = ref(false)
    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')
    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    async function login() {
        try {
            const response = await AuthenticationService.login({
            username: username.value,
            password: password.value
            })
            
            if(response.status == 200){
                msgStatus.value = 'success'
                msg.value = 'Logged in successfully'

                //console.log(response.data.token)
                if(response.data.token != null){
                    var token = response.data.token
                    var user = response.data.user.username
                    var roles = response.data.user.roles

                    try{
                        await authStore.setToken(token,user,roles)
                        router.push('/')
                    }catch(err){
                        msgStatus.value = 'error'
                        msg.value = "Error in setting token"
                    }
                    
                }
            }else{
                msgStatus.value = 'error'
                msg.value = response.response.data.error
            }
            // this.$router.push('/')
        } catch (err) {
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        showMessage.value = true
        //authStore.$reset()
    }

    function closesnackbar (){
        showMessage.value = false
    }

</script>